import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({ name: 'assetsPath' })
export class AssetsPathPipe implements PipeTransform {
  transform(value: string, forStyle?: boolean): string {
    if (!value) return '';
    if (!value.startsWith('/')) value = `/${value}`;
    const path = value ? `${environment.app.cdnURL}assets${value}` : '';

    return forStyle ? `url(${path})` : path;
  }
}
